import PropTypes from "prop-types";
import React, { useState } from "react";
import Modal from "../../components/Modal";
import Input from "../../elements/input";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";

const InputModal = props => {
  const { headingType, headingBody, zipCodeLabel, zipCodeFormatErrorMessage, zipCodeRequiredErrorMessage, submitCTA, callback, id, showModal, setShowModal } = props;
  const [inputText, setInputText] = useState("");
  const onClicked = () => {
    setShowModal(false);
    console.log(inputText);
    if (callback && inputText !== "") {
      callback(inputText);
    }
  };
  return (
    <Modal className="input-modal" showModal={showModal} setShowModal={setShowModal} onCloseClicked={() => setShowModal(false)} id={id}>
      <Heading
        {...{
          type: headingType || { fields: { phrase: { value: "h1" } } },
          html: headingBody
        }}
        typographyClass="type-h1"
        className="heading"
      />
      <Input
        {...{
          label: zipCodeLabel?.value,
          warningMessage: zipCodeFormatErrorMessage?.value
        }}
        className="input"
        onChange={evt => setInputText(evt.target.value)}
      />
      <PrimaryButton
        {...{
          ...submitCTA?.fields,
          buttonText: submitCTA?.fields?.buttonText?.value
        }}
        isDisabled={!inputText}
        callback={onClicked}
      />
    </Modal>
  );
};

InputModal.propTypes = {
  heading: PropTypes.object,
  input: PropTypes.object,
  button: PropTypes.object,
  callback: PropTypes.func,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func
};

export default InputModal;
